import moment from 'moment';
import './CookieModal.scss';
export class CookieModalController {
    static $inject = ['SegmentService', 'AccountService2', 'close'];
    constructor(SegmentService, AccountService2, close) {
        this.SegmentService = SegmentService;
        this.AccountService2 = AccountService2;
        this.close = close;
        this.COOKIE_ACCEPTED = 'portal-cookiesmodal-accepted';
        this.MORE_INFORMATION = 'portal-cookiesmodal-more-information-clicked';
        this.COOKIE_POLICY = 'portal-cookiesmodal-policy-clicked';
        this.COOKIES_HELP_URL = 'http://help.blip.ai/docs/en/security/cookies/';
        this.MAILTO_LEGAL = 'mailto:legal@blip.ai';
        this.TARGET_BLANK = '_blank';
        this.onInit();
    }
    async onInit() {
        this.account = await this.AccountService2.me();
    }
    async cookieAccept() {
        await this.AccountService2.setExtras({
            ...this.account.extras,
            cookies: JSON.stringify({ ...this.account.extras?.cookies, portalAcceptedCookiesDate: moment().format() }),
        });
        this.SegmentService.createOrganizationTrack(this.COOKIE_ACCEPTED);
        this.close();
    }
    async moreInformation() {
        this.SegmentService.createOrganizationTrack(this.MORE_INFORMATION);
        window.open(this.MAILTO_LEGAL, this.TARGET_BLANK);
    }
    async trackCookiesPolicy() {
        this.SegmentService.createOrganizationTrack(this.COOKIE_POLICY);
        window.open(this.COOKIES_HELP_URL, this.TARGET_BLANK);
    }
}
CookieModalController.$inject = ['SegmentService', 'AccountService2', 'close'];
